import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { Icon } from '@/app/components/icons';
import { IconCheck } from '@/app/components/icons/ui-actions/icon-check';
import styles from '@/app/lcv/components/sections/calculator/styles.module.css';
import { cn } from '@/app/utils/cn';
interface ItemProps {
  children?: ReactNode;
  label?: string;
}
export const FreeText = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="center-x center-y absolute size-8.25 rounded-full bg-red-500" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="relative">{t1}<span className="font-noto-bold relative mx-2 px-2 text-white">{text}</span></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const ItemRow = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid items-center gap-y-4", styles.privilegeItemRow);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const ItemRowDetail = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid items-center", styles.privilegeItemRowDetail);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const PrivilegeDetailRowLabel = t0 => {
  const $ = _c(3);
  const {
    label
  } = t0;
  if (!label) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon icon={<IconCheck />} className="inline-block size-5 align-middle text-red-500" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span>{t1}{" "}{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};